import { render, staticRenderFns } from "./WhatIfSlide.vue?vue&type=template&id=4e4adad7&scoped=true"
import script from "./WhatIfSlide.vue?vue&type=script&lang=js"
export * from "./WhatIfSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4adad7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e4adad7')) {
      api.createRecord('4e4adad7', component.options)
    } else {
      api.reload('4e4adad7', component.options)
    }
    module.hot.accept("./WhatIfSlide.vue?vue&type=template&id=4e4adad7&scoped=true", function () {
      api.rerender('4e4adad7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/teacher/vue/slides/WhatIfSlide.vue"
export default component.exports